var cell_default = {
  "cell": "B1FWB",
  "header": "CRmwF",
  "selected": "pZh8f",
  "editing": "phfax",
  "singleSelection": "ZQ-cA",
  "hideLastBlock": "HV27A",
  "editorWrapper": "NSRTi",
  "viewerWrapper": "JRDfB",
  "hideFirstBlock": "M446e",
  "editor": "Xk-qW",
  "edit": "Y1eIb",
  "view": "_3Y37r",
  "editingToolbarWrapper": "Au5vx",
  "selectAll": "-F4WU",
  "disableSelection": "_9AfYb"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
